import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export type PasswordStrengthLevel = 'faible' | 'moyen' | 'fort';

export function passwordPolicyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = control.value || '';
    const errors: ValidationErrors = {};

    if (value.length < 8) { errors.minlength = true; }
    if (!/[a-z]/.test(value)) { errors.lowercase = true; }
    if (!/[A-Z]/.test(value)) { errors.uppercase = true; }
    if (!/\d/.test(value)) { errors.digit = true; }
    if (!/[^A-Za-z0-9]/.test(value)) { errors.specialChar = true; }

    return Object.keys(errors).length ? errors : null;
  };
}

export function getPasswordStrength(value: string): { level: PasswordStrengthLevel; score: number } {
  if (!value) {
    return { level: 'faible', score: 0 };
  }

  let score = 0;
  if (value.length >= 8) { score++; }
  if (value.length >= 12) { score++; }
  if (/[a-z]/.test(value)) { score++; }
  if (/[A-Z]/.test(value)) { score++; }
  if (/\d/.test(value)) { score++; }
  if (/[^A-Za-z0-9]/.test(value)) { score++; }

  if (score <= 2) { return { level: 'faible', score }; }
  if (score <= 4) { return { level: 'moyen', score }; }
  return { level: 'fort', score };
}
